import { render, staticRenderFns } from "./VConfirmationDialog.vue?vue&type=template&id=35de984e"
import script from "./VConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./VConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports